export interface AuthStateModel {
  authToken: string | undefined;
}

export const defaults: AuthStateModel = {
  authToken: undefined,
};
